import React from "react";
import { Dropdown } from "react-bootstrap";
import Pagination from "react-bootstrap/Pagination";

function ManageActivityPagination(props: {
  page: number;
  setPage: (page: number) => void;
  totalPages: number;
  limit: number;
  setLimit: (limit: number) => void;
}) {
  const { page, setPage, totalPages, limit, setLimit } = props;

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);

  return (
    <main className="d-flex justify-content-start align-items-center mt-3 gap-4">
      <Dropdown>
        <Dropdown.Toggle
          className="btn-flat"
          variant="success"
          id="dropdown-basic"
        >
          {limit} Limit
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item onClick={() => setLimit(5)}>5</Dropdown.Item>
          <Dropdown.Item onClick={() => setLimit(10)}>10</Dropdown.Item>
          <Dropdown.Item onClick={() => setLimit(20)}>20</Dropdown.Item>
          <Dropdown.Item onClick={() => setLimit(50)}>50</Dropdown.Item>
          <Dropdown.Item onClick={() => setLimit(100)}>100</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <Pagination className="mb-0">
        <Pagination.Prev onClick={() => page > 1 && setPage(page - 1)} />
        {Array.from({ length: totalPages || 0 }, (_, index) => (
          <Pagination.Item
            key={index}
            active={index + 1 === page}
            onClick={() => setPage(index + 1)}
          >
            {index + 1}
          </Pagination.Item>
        ))}
        <Pagination.Next
          onClick={() => page < (totalPages || 0) && setPage(page + 1)}
        />
      </Pagination>
    </main>
  );
}

export default ManageActivityPagination;
